// extracted by mini-css-extract-plugin
module.exports = {"totalLiquidity":"PoolShares-module--totalLiquidity--3upZQ","poolSharesTable":"PoolShares-module--poolSharesTable--3TvWd","userLiquidity":"PoolShares-module--userLiquidity--2x9ZI"};